/* eslint-disable angular/timeout-service */
/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import BarLoader from 'react-spinners/BarLoader';
import DatePicker from './video-solution-components/DatePicker';
import UserDropdown from './video-solution-components/UserDropdown';
import SearchBox from './video-solution-components/SearchBox';
import VideoForm from './video-solution-components/VideoForm';

function VideoSolution({ adminRole = false }) {
    return (
        <>
            <div className='personal-video-page'>
                <div className='flex-basis-4 block-all margin-t-8px'>
                    <DatePicker />
                    <Suspense fallback={<BarLoader color='#3367F2' />}>
                        {adminRole && <UserDropdown />}
                        <SearchBox />
                    </Suspense>
                </div>
                <div className='flex-basis-4 block-all'>
                    <h2>Landing Page Options</h2>
                </div>
                <div className='flex-full block-all'>
                    <h2>Video Solution</h2>
                    <div className='video-details'>
                        <Suspense fallback={<BarLoader color='#3367F2' />}>
                            <VideoForm/>
                        </Suspense>
                    </div>
                    {/* potentially where we put the recorder - but would have to figure out how to bring an angular component into React */}
                </div>
            </div>
        </>
    );
}

VideoSolution.propTypes = {
    adminRole: PropTypes.boolean,
};

export default VideoSolution;
